import { addMinutesToDate } from 'common/helpers/dates';

export const checkAppoitmentAvailabilityTime = (
	startTime: number,
	duration: number,
) => addMinutesToDate(startTime, duration).getTime() >= new Date().getTime();
